export const sendSupportEmail = async ({ requestBody, navigate }) => {
  try {
    const response = await fetch("/api/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestBody, type: "support" }),
    });

    if (!response.ok) {
      throw new Error(`Email send failed: ${response.status}`);
    }

    const result = await response.json();
    console.log("Support email sent successfully:", result);
  } catch (error) {
    console.error("Error sending support email:", error);
    navigate(`/error?message=${encodeURIComponent(error.message)}`);
  }
};

export const postCase = async ({ requestBody, navigate }) => {
  const url = "/api/postCase";

  try {
    if (!requestBody.ContactId) {
      throw new Error(
        "You're not logged in, please click retry to login and then proceed."
      );
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(`API call failed with status ${response.status}`);
    }

    // Check if API returned an error response
    if (responseData?.status === 500) {
      navigate(`/error?message=Internal Server Error`);
      return;
    }

    return responseData;
  } catch (error) {
    console.error("Error saving quote:", error);
    navigate(`/error?message=${encodeURIComponent(error.message)}`);
  }
};
